angular = require( 'angular' )

app = angular.module( 'workflow.app' )
app.directive( 'document', require( './Document' ))
app.directive( 'uploadedDocumentPreview', require( './UploadedDocumentPreview' ))

require('./SearchResultPreview')
require('./DocumentActionsToolbar')
require('./AutoDisposition')
require('./TaggingToolbar')
require('./EntityModal')
